import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import CTAPanel from "@/components/base/CTAPanel";

const serviceAreas = [
  {
    title: "Website Development",
    description: "Mitaja provides website development capabilities for enterprise and government clients, building modern, accessible web experiences.",
    icon: "ri-global-line",
  },
  {
    title: "CMS Solutions",
    description: "Content management system solutions and support, including SharePoint-based site creation and content organization.",
    icon: "ri-global-line",
  },
  {
    title: "Website Modernization",
    description: "Website modernization and refresh services to update existing web properties with contemporary design and technology standards.",
    icon: "ri-global-line",
  },
  {
    title: "Web Portals",
    description: "Enterprise web portal development and support for internal and external user access to information and services.",
    icon: "ri-global-line",
  },
  {
    title: "Content Migration",
    description: "Content migration services for website and CMS transitions, ensuring data integrity and continuity during platform changes.",
    icon: "ri-global-line",
  },
  {
    title: "Website Maintenance",
    description: "Ongoing website maintenance and support services for enterprise web properties and digital platforms.",
    icon: "ri-global-line",
  },
  {
    title: "Integration Support",
    description: "Integration support connecting web platforms with enterprise data sources, applications, and backend systems.",
    icon: "ri-global-line",
  },
  {
    title: "Accessibility-Aware Development",
    description: "Web development practices that consider accessibility standards and usability for diverse user populations.",
    icon: "ri-global-line",
  },
];

export default function WebDigitalSolutions() {
  return (
    <Layout>
      <PageHero
        title="Web & Digital Solutions"
        subtitle="Website Development & Digital Services"
        description="Website development, CMS solutions, web portals, content migration, and accessibility-aware development for modern digital environments."
        size="md"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <SectionHeader
            title="Service Areas"
            description="Web and digital capabilities that support enterprise and government modernization initiatives."
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {serviceAreas.map((area) => (
              <div key={area.title} className="card-base p-6">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                  <i className={`${area.icon} text-primary-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-foreground-900 mb-2">
                  {area.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {area.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTAPanel
        title="Need Web or Digital Support?"
        description="Mitaja can provide web development and digital solutions as part of broader enterprise technology engagements."
        primaryAction={{ label: "Contact Us", href: "/contact" }}
        secondaryAction={{ label: "View All Capabilities", href: "/capabilities" }}
        variant="dark"
      />
    </Layout>
  );
}